// extracted by mini-css-extract-plugin
export default {"errorText":"src-modules-session-sales-individual-reservations-style__errorText_iK1AR"};